class ItemAttributeSet implements MerchantosItemAttributeSet {
  toggleAttributeFields = (object: { selectedIndex: number; [key: string]: any }) => {
    // Remove initial hidden rows, 1 row shown by default
    $('.attribute_2')
      .closest('tr')
      .removeClass('hidden');
    $('.attribute_3')
      .closest('tr')
      .removeClass('hidden');

    switch (object.selectedIndex) {
      case 0: {
        $('.attribute_1')
          .closest('tr')
          .show();
        $('.attribute_2')
          .closest('tr')
          .hide();
        $('.attribute_2').val('');
        $('.attribute_3')
          .closest('tr')
          .hide();
        $('.attribute_3').val('');
        break;
      }
      case 1: {
        $('.attribute_1')
          .closest('tr')
          .show();
        $('.attribute_2')
          .closest('tr')
          .show();
        $('.attribute_3')
          .closest('tr')
          .hide();
        $('.attribute_3').val('');
        break;
      }
      case 2: {
        $('.attribute_1')
          .closest('tr')
          .show();
        $('.attribute_2')
          .closest('tr')
          .show();
        $('.attribute_3')
          .closest('tr')
          .show();
        break;
      }
      default: {
        // swallow
      }
    }
  };
}

window.merchantos.item_attribute_set = new ItemAttributeSet();
